import { useState, useEffect } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../util/firebase";
import { query, collection, getDocs, where, addDoc } from "firebase/firestore";

import { v4 as uuidv4 } from "uuid";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
import { Button, Input, Modal, ModalBody } from "reactstrap";
import { IoClose } from "react-icons/io5";

// import emailjs from '@emailjs/browser';

function AdminCreateGroupPage() {
  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  // eslint-disable-next-line
  const [userData, setUserData] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setUserData(data);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  const sports = [
    // 'Test',
    "Soccer",
    "Football",
    "Baseball",
    "Hockey",
    "Racing",
    "Basketball",
    "MMA",
    // 'College football',
    // 'College Basketball'
  ];

  const [leagues, setLeagues] = useState();
  const [teams, setTeams] = useState();

  const fetchLeagues = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "leagues"));
      const doc = await getDocs(q);
      const data = doc.docs.map((doc) => doc.data());

      let fetchedTeams = [];
      data.forEach((league) => {
        if (league.teams) {
          league.teams.forEach((team) => {
            fetchedTeams.push({
              league: league.name,
              name: team.name,
            });
          });
        }
      });

      setLeagues(data);
      setTeams(fetchedTeams);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching leagues");
    }
  };

  useEffect(() => {
    fetchLeagues();
    // eslint-disable-next-line
  }, []);
  // [
  // 	{
  // 		sport: 'Soccer',
  // 		leagues: [
  //       'Liga Mayor de Futbol Salvadoreño',
  // 			'Premier League',
  // 			'LaLiga',
  //       'MLS',
  // 			'Serie A',
  // 			'Bundesliga',
  // 			'Ligue 1',
  //       'Liga MX',
  //       'Primera Division Argentina',
  // 			'UEFA Champions League',
  // 			'UEFA Europa League',
  // 			'FIFA World Cup',
  // 			'UEFA European Championship',
  // 			'Copa America',
  // 			'CONCACAF Gold Cup',
  // 			'FIFA Club World Cup',
  // 		]
  // 	},
  // 	{
  // 		sport: 'Football',
  // 		leagues: [
  // 			'NFL',
  // 			// 'NCAA',
  // 			// 'Canadian Football League',
  // 			// 'Arena Football League',
  // 			// 'XFL',
  // 			// 'USFL',
  // 			// 'NFL Europe',
  // 			// 'World League of American Football',
  // 			// 'United Football League',
  // 			// 'Alliance of American Football'
  // 		]
  // 	},
  //   {
  // 		sport: 'Baseball',
  // 		leagues: [
  // 			'MLB',
  // 		]
  // 	},
  //   {
  // 		sport: 'Hockey',
  // 		leagues: [
  // 			'NHL',
  // 		]
  // 	},
  //   {
  // 		sport: 'Racing',
  // 		leagues: [
  // 			'Formula 1',
  // 		]
  // 	},
  //   {
  // 		sport: 'Basketball',
  // 		leagues: [
  // 			'NBA',
  // 		]
  // 	},
  //   {
  // 		sport: 'MMA',
  // 		leagues: [
  // 			'UFC',
  // 		]
  // 	}
  // ]

  // eslint-disable-next-line
  // const [teams, setTeams] = useState();
  //     {
  // 			league: 'Liga Mayor de Futbol Salvadoreño',
  // 			team: 'Alianza F.C.'
  // 		},
  //     {
  // 			league: 'Liga Mayor de Futbol Salvadoreño',
  // 			team: 'C.D. Luis Angel Firpo'
  // 		},
  //     {
  // 			league: 'Liga Mayor de Futbol Salvadoreño',
  // 			team: 'C.D. Municipal Limeño'
  // 		},
  //     {
  // 			league: 'Liga Mayor de Futbol Salvadoreño',
  // 			team: 'C.D. Aguila'
  // 		},
  //     {
  // 			league: 'Liga Mayor de Futbol Salvadoreño',
  // 			team: 'C.D. FAS'
  // 		},
  //     {
  // 			league: 'Liga Mayor de Futbol Salvadoreño',
  // 			team: 'Platense'
  // 		},
  //     {
  // 			league: 'Liga Mayor de Futbol Salvadoreño',
  // 			team: 'A.D. Isidro Metapan'
  // 		},
  //     {
  // 			league: 'Liga Mayor de Futbol Salvadoreño',
  // 			team: '11 Deportivo F.C.'
  // 		},
  //     {
  // 			league: 'Liga Mayor de Futbol Salvadoreño',
  // 			team: 'Dragon'
  // 		},
  //     {
  // 			league: 'Liga Mayor de Futbol Salvadoreño',
  // 			team: 'C.D. Cacahuatique'
  // 		},
  //     {
  // 			league: 'Liga Mayor de Futbol Salvadoreño',
  // 			team: 'Fuerte San Francisco'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Arsenal'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Aston Villa'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Bournemouth'
  // 		},
  //     {
  // 			league: 'Premier League',
  // 			team: 'Brentford'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Brighton & Hove Albion'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Chelsea'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Crystal Palace'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Everton'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Fulham'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Ipswich Town'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Liverpool'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Manchester City'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Manchester United'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Newcastle United'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Nottingham Forest'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Southampton'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Tottenham Hotspur',
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'West Ham United'
  // 		},
  // 		{
  // 			league: 'Premier League',
  // 			team: 'Wolverhampton Wanderers'
  // 		},
  //     {
  // 			league: 'Premier League',
  // 			team: 'Leicester City'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Real Madrid'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Barcelona'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Girona'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Real Sociedad'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'UD Las Palmas'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Deportivo Alaves'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Celta de Vigo'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Rayo Vallecano'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Villarreal C.F.'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Atletico Madrid'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Sevilla F.C.'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'RCD Mallorca'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Valencia C.F.'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Athletic Bilbao'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'R.C.D. Espanyol'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Real Betis'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Getafe C.F.'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'Real Valladolid'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'C.A. Osasuna'
  // 		},
  //     {
  // 			league: 'LaLiga',
  // 			team: 'C.D. Leganes'
  // 		},
  //     {league: 'MLS', team: 'Inter Miami CF'},
  //     {league: 'MLS', team: 'FC Cincinnati'},
  //     {league: 'MLS', team: 'Columbus Crew'},
  //     {league: 'MLS', team: 'New York Red Bulls'},
  //     {league: 'MLS', team: 'New York City FC'},
  //     {league: 'MLS', team: 'Charlotte FC'},
  //     {league: 'MLS', team: 'Orlando City SC'},
  //     {league: 'MLS', team: 'Toronto FC'},
  //     {league: 'MLS', team: 'Atlanta United FC'},
  //     {league: 'MLS', team: 'Philadelphia Union'},
  //     {league: 'MLS', team: 'CF Montréal'},
  //     {league: 'MLS', team: 'Nashville SC'},
  //     {league: 'MLS', team: 'DC United'},
  //     {league: 'MLS', team: 'Chicago Fire FC'},
  //     {league: 'MLS', team: 'New England Revolution'},
  //     {league: 'MLS', team: 'LA Galaxy'},
  // 		{league: 'MLS', team: 'San Diego FC'},
  //     {league: 'MLS', team: 'LAFC'},
  //     {league: 'MLS', team: 'Real Salt Lake'},
  //     {league: 'MLS', team: 'Colorado Rapids'},
  //     {league: 'MLS', team: 'Vancouver Whitecaps'},
  //     {league: 'MLS', team: 'Houston Dynamo FC'},
  //     {league: 'MLS', team: 'Seattle Sounders FC'},
  //     {league: 'MLS', team: 'Portland Timbers'},
  //     {league: 'MLS', team: 'Minnesota United FC'},
  //     {league: 'MLS', team: 'Austin FC'},
  //     {league: 'MLS', team: 'FC Dallas'},
  //     {league: 'MLS', team: 'Sporting Kansas City'},
  //     {league: 'MLS', team: 'St. Louis City SC'},
  //     {league: 'MLS', team: 'San Jose Earthquakes'},
  //     {league: 'Bundesliga', team: 'Bayer 04 Leverkusen'},
  //     {league: 'Bundesliga', team: 'VfB Stuttgart'},
  //     {league: 'Bundesliga', team: 'FC Bayern München'},
  //     {league: 'Bundesliga', team: 'RB Leipzig'},
  //     {league: 'Bundesliga', team: 'Borussia Dortmund'},
  //     {league: 'Bundesliga', team: 'Eintracht Frankfurt'},
  //     {league: 'Bundesliga', team: 'TSG Hoffenheim'},
  //     {league: 'Bundesliga', team: '1. FC Heidenheim 1846'},
  //     {league: 'Bundesliga', team: 'SV Werder Bremen'},
  //     {league: 'Bundesliga', team: 'SC Freiburg'},
  //     {league: 'Bundesliga', team: 'FC Augsburg'},
  //     {league: 'Bundesliga', team: 'VfL Wolfsburg'},
  //     {league: 'Bundesliga', team: '1. FSV Mainz 05'},
  //     {league: 'Bundesliga', team: 'Borussia Mönchengladbach'},
  //     {league: 'Bundesliga', team: '1. FC Union Berlin'},
  //     {league: 'Bundesliga', team: 'VfL Bochum 1848'},
  //     {league: 'Bundesliga', team: 'FC St. Pauli'},
  //     {league: 'Bundesliga', team: 'Holstein Kiel'},
  //     {league: 'Serie A', team: 'Atalanta'},
  //     {league: 'Serie A', team: 'Bologna'},
  //     {league: 'Serie A', team: 'Cagliari'},
  //     {league: 'Serie A', team: 'Como'},
  //     {league: 'Serie A', team: 'Empoli'},
  //     {league: 'Serie A', team: 'Fiorentina'},
  //     {league: 'Serie A', team: 'Genoa'},
  //     {league: 'Serie A', team: 'Hellas Verona'},
  //     {league: 'Serie A', team: 'Inter Milan'},
  //     {league: 'Serie A', team: 'Juventus'},
  //     {league: 'Serie A', team: 'Lazio'},
  //     {league: 'Serie A', team: 'Lecce'},
  //     {league: 'Serie A', team: 'AC Milan'},
  //     {league: 'Serie A', team: 'Monza'},
  //     {league: 'Serie A', team: 'Napoli'},
  //     {league: 'Serie A', team: 'Parma'},
  //     {league: 'Serie A', team: 'Roma'},
  //     {league: 'Serie A', team: 'Torino'},
  //     {league: 'Serie A', team: 'Udinese'},
  //     {league: 'Serie A', team: 'Venezia'},
  //     {league: 'Ligue 1', team: 'Angers'},
  //     {league: 'Ligue 1', team: 'Auxerre'},
  //     {league: 'Ligue 1', team: 'Brest'},
  //     {league: 'Ligue 1', team: 'Le Havre'},
  //     {league: 'Ligue 1', team: 'Lens'},
  //     {league: 'Ligue 1', team: 'Lille'},
  //     {league: 'Ligue 1', team: 'Lyon'},
  //     {league: 'Ligue 1', team: 'Marseille'},
  //     {league: 'Ligue 1', team: 'Monaco'},
  //     {league: 'Ligue 1', team: 'Montpellier'},
  //     {league: 'Ligue 1', team: 'Nantes'},
  //     {league: 'Ligue 1', team: 'Nice'},
  //     {league: 'Ligue 1', team: 'Paris Saint-Germain'},
  //     {league: 'Ligue 1', team: 'Reims'},
  //     {league: 'Ligue 1', team: 'Rennes'},
  //     {league: 'Ligue 1', team: 'Saint-Étienne'},
  //     {league: 'Ligue 1', team: 'Strasbourg'},
  //     {league: 'Ligue 1', team: 'Toulouse'},
  //     {league: 'Liga MX', team: 'Club América'},
  //     {league: 'Liga MX', team: 'Atlas FC'},
  //     {league: 'Liga MX', team: 'Atlético de San Luis'},
  //     {league: 'Liga MX', team: 'CD Cruz Azul'},
  //     {league: 'Liga MX', team: 'CD Guadalajara'},
  //     {league: 'Liga MX', team: 'Club León'},
  //     {league: 'Liga MX', team: 'FC Juárez'},
  //     {league: 'Liga MX', team: 'Mazatlán FC'},
  //     {league: 'Liga MX', team: 'CF Monterrey'},
  //     {league: 'Liga MX', team: 'Club Necaxa'},
  //     {league: 'Liga MX', team: 'CF Pachuca'},
  //     {league: 'Liga MX', team: 'Club Puebla'},
  //     {league: 'Liga MX', team: 'Querétaro FC'},
  //     {league: 'Liga MX', team: 'Santos Laguna'},
  //     {league: 'Liga MX', team: 'Tigres UANL'},
  //     {league: 'Liga MX', team: 'Club Tijuana'},
  //     {league: 'Liga MX', team: 'Deportivo Toluca FC'},
  //     {league: 'Liga MX', team: 'Universidad Nacional'},
  //     {league: 'Primera División Argentina', team: 'Argentinos Juniors'},
  //     {league: 'Primera División Argentina', team: 'Atlético Tucumán'},
  //     {league: 'Primera División Argentina', team: 'Banfield'},
  //     {league: 'Primera División Argentina', team: 'Barracas Central'},
  //     {league: 'Primera División Argentina', team: 'Belgrano'},
  //     {league: 'Primera División Argentina', team: 'Boca Juniors'},
  //     {league: 'Primera División Argentina', team: 'Central Córdoba'},
  //     {league: 'Primera División Argentina', team: 'Defensa y Justicia'},
  //     {league: 'Primera División Argentina', team: 'Deportivo Riestra'},
  //     {league: 'Primera División Argentina', team: 'Estudiantes de La Plata'},
  //     {league: 'Primera División Argentina', team: 'Gimnasia y Esgrima La Plata'},
  //     {league: 'Primera División Argentina', team: 'Godoy Cruz'},
  //     {league: 'Primera División Argentina', team: 'Huracán'},
  //     {league: 'Primera División Argentina', team: 'Independiente'},
  //     {league: 'Primera División Argentina', team: 'Independiente Rivadavia'},
  //     {league: 'Primera División Argentina', team: 'Instituto'},
  //     {league: 'Primera División Argentina', team: 'Lanús'},
  //     {league: 'Primera División Argentina', team: "Newell's Old Boys"},
  //     {league: 'Primera División Argentina', team: 'Platense'},
  //     {league: 'Primera División Argentina', team: 'Racing Club'},
  //     {league: 'Primera División Argentina', team: 'River Plate'},
  //     {league: 'Primera División Argentina', team: 'Rosario Central'},
  //     {league: 'Primera División Argentina', team: 'San Lorenzo'},
  //     {league: 'Primera División Argentina', team: 'Sarmiento'},
  //     {league: 'Primera División Argentina', team: 'Talleres'},
  //     {league: 'Primera División Argentina', team: 'Tigre'},
  //     {league: 'Primera División Argentina', team: 'Unión'},
  //     {league: 'Primera División Argentina', team: 'Vélez Sarsfield'},
  //     {league: 'UEFA Champions League', team: 'Manchester City F.C.'},
  // {league: 'UEFA Champions League', team: 'F.C. Bayern Munich'},
  // {league: 'UEFA Champions League', team: 'Real Madrid C.F.'},
  // {league: 'UEFA Champions League', team: 'PSG'},
  // {league: 'UEFA Champions League', team: 'Liverpool'},
  // {league: 'UEFA Champions League', team: 'Inter Milan'},
  // {league: 'UEFA Champions League', team: 'Borussia Dortmund'},
  // {league: 'UEFA Champions League', team: 'RB Leipzig'},
  // {league: 'UEFA Champions League', team: 'F.C. Barcelona'},
  // {league: 'UEFA Champions League', team: 'Feyenoord'},
  // {league: 'UEFA Champions League', team: 'Sporting C.P.'},
  // {league: 'UEFA Champions League', team: 'PSV'},
  // {league: 'UEFA Champions League', team: 'GNK Dinamo Zagreb'},
  // {league: 'UEFA Champions League', team: 'F.C. RB Salzburg'},
  // {league: 'UEFA Champions League', team: 'LOSC Lille'},
  // {league: 'UEFA Champions League', team: 'Red Star Belgrade'},
  // {league: 'UEFA Champions League', team: 'B.SC. Young Boys'},
  // {league: 'UEFA Champions League', team: 'Celtic F.C.'},
  // {league: 'UEFA Champions League', team: 'Bayer 04 Leverkusen'},
  // {league: 'UEFA Champions League', team: 'Atletico Madrid'},
  // {league: 'UEFA Champions League', team: 'Atalanta B.C.'},
  // {league: 'UEFA Champions League', team: 'Juventus F.C.'},
  // {league: 'UEFA Champions League', team: 'S.L. Benfica'},
  // {league: 'UEFA Champions League', team: 'Arsenal F.C.'},
  // {league: 'UEFA Champions League', team: 'Club Brugge K.V.'},
  // {league: 'UEFA Champions League', team: 'F.C. Shakhtar Donetsk'},
  // {league: 'UEFA Champions League', team: 'A.C. Milan'},
  // {league: 'UEFA Champions League', team: 'S.K. Slovan Bratislava'},
  // {league: 'UEFA Champions League', team: 'AS Monaco'},
  // {league: 'UEFA Champions League', team: 'A.C. Sparta Praha'},
  // {league: 'UEFA Champions League', team: 'Aston Villa F.C.'},
  // {league: 'UEFA Champions League', team: 'Bologna F.C. 1909'},
  // {league: 'UEFA Champions League', team: 'Girona F.C.'},
  // {league: 'UEFA Champions League', team: 'VfB Stuttgart'},
  // {league: 'UEFA Champions League', team: 'SK Sturm Graz'},
  // {league: 'UEFA Champions League', team: 'Stade Brestois 29'},
  // {league: 'UEFA Europa League', team: 'Manchester United'},
  // {league: 'UEFA Europa League', team: 'Tottenham Hotspur'},
  // {league: 'UEFA Europa League', team: 'Real Sociedad'},
  // {league: 'UEFA Europa League', team: 'Roma'},
  // {league: 'UEFA Europa League', team: 'Athletic Club Bilbao'},
  // {league: 'UEFA Europa League', team: 'F.C. Porto'},
  // {league: 'UEFA Europa League', team: 'Olympique Lyon'},
  // {league: 'UEFA Europa League', team: 'A.F.C. Ajax'},
  // {league: 'UEFA Europa League', team: 'Eintracht Frankfurt'},
  // {league: 'UEFA Europa League', team: 'S.S. Lazio'},
  // {league: 'UEFA Europa League', team: 'O.G.C. Nice'},
  // {league: 'UEFA Europa League', team: 'Fenerbahce S.K.'},
  // {league: 'UEFA Europa League', team: 'Galatasaray S.K.'},
  // {league: 'UEFA Europa League', team: 'TSG Hoffenheim'},
  // {league: 'UEFA Europa League', team: 'Besiktas J.K.'},
  // {league: 'UEFA Europa League', team: 'S.C. Braga'},
  // {league: 'UEFA Europa League', team: 'R.S.C. Anderlecht'},
  // {league: 'UEFA Europa League', team: 'PAOK F.C.'},
  // {league: 'UEFA Europa League', team: 'Olympiacos F.C.'},
  // {league: 'UEFA Europa League', team: 'S.K. Slavia Prague'},
  // {league: 'UEFA Europa League', team: 'Rangers F.C.'},
  // {league: 'UEFA Europa League', team: 'F.C. Dynamo Kyiv'},
  // {league: 'UEFA Europa League', team: 'Royal Union Saint-Gilloise'},
  // {league: 'UEFA Europa League', team: 'AZ Alkmaar'},
  // {league: 'UEFA Europa League', team: 'F.C. Twente'},
  // {league: 'UEFA Europa League', team: 'F.C. Midtjylland'},
  // {league: 'UEFA Europa League', team: 'Ferencvarosi T.C.'},
  // {league: 'UEFA Europa League', team: 'Ludogorets Razgrad'},
  // {league: 'UEFA Europa League', team: 'F.K. Bodø/Glimt'},
  // {league: 'UEFA Europa League', team: 'F.C.S.B.'},
  // {league: 'UEFA Europa League', team: 'F.C. Viktoria Plzeň'},
  // {league: 'UEFA Europa League', team: 'Malmö F.F.'},
  // {league: 'UEFA Europa League', team: 'Maccabi Tel Aviv F.C.'},
  // {league: 'UEFA Europa League', team: 'Qarabağ F.K.'},
  // {league: 'UEFA Europa League', team: 'I.F. Elfsborg'},
  // {league: 'UEFA Europa League', team: 'Riga F.C.'},
  // 		//
  //     {league: 'FORMULA 1', team: 'Max Verstappen 🇳🇱 (Red Bull Racing)'},
  //     {league: 'FORMULA 1', team: 'Sergio Perez 🇲🇽 (Red Bull Racing)'},
  //     {league: 'FORMULA 1', team: 'Charles Leclerc 🇲🇨 (Ferrari)'},
  //     {league: 'FORMULA 1', team: 'Carlos Sainz 🇪🇸 (Ferrari)'},
  //     {league: 'FORMULA 1', team: 'Lando Norris 🇬🇧 (McLaren'},
  //     {league: 'FORMULA 1', team: 'Oscar Piastri 🇦🇺 (McLaren'},
  //     {league: 'FORMULA 1', team: 'Lewis Hamilton 🇬🇧 (Mercedes)'},
  //     {league: 'FORMULA 1', team: 'George Russell 🇬🇧 (Mercedes)'},
  //     {league: 'FORMULA 1', team: 'Esteban Ocon 🇫🇷 (Alpine)'},
  //     {league: 'FORMULA 1', team: 'Pierre Gasly 🇫🇷 (Alpine)'},
  //     {league: 'FORMULA 1', team: 'Valtteri Bottas 🇫🇮 (Kick Sauber)'},
  //     {league: 'FORMULA 1', team: 'Zhou Guanyu 🇨🇳 (Kick Sauber)'},
  //     {league: 'FORMULA 1', team: 'Lance Stroll 🇨🇦 (Aston Martin)'},
  //     {league: 'FORMULA 1', team: 'Fernando Alonso 🇪🇸 (Aston Martin)'},
  //     {league: 'FORMULA 1', team: 'Kevin Magnussen 🇩🇰 (HAAS F1 Team)'},
  //     {league: 'FORMULA 1', team: 'Nico Hulkenberg 🇩🇪 (HAAS F1 Team'},
  //     {league: 'FORMULA 1', team: 'Daniel Ricciardo 🇦🇺 (RB)'},
  //     {league: 'FORMULA 1', team: 'Yuki Tsunoda 🇯🇵 (RB)'},
  //     {league: 'FORMULA 1', team: 'Alexander Albon 🇹🇭 (Williams)'},
  //     {league: 'FORMULA 1', team: 'Logan Sargeant 🇺🇸 (Williams)'},
  //     //
  //     {league: 'NFL', team: 'Arizona Cardinals'},
  //     {league: 'NFL', team: 'Atlanta Falcons'},
  //     {league: 'NFL', team: 'Baltimore Ravens'},
  //     {league: 'NFL', team: 'Buffalo Bills'},
  //     {league: 'NFL', team: 'Carolina Panthers'},
  //     {league: 'NFL', team: 'Chicago Bears'},
  //     {league: 'NFL', team: 'Cincinnati Bengals'},
  //     {league: 'NFL', team: 'Cleveland Browns'},
  //     {league: 'NFL', team: 'Dallas Cowboys'},
  //     {league: 'NFL', team: 'Denver Broncos'},
  //     {league: 'NFL', team: 'Detroit Lions'},
  //     {league: 'NFL', team: 'Green Bay Packers'},
  //     {league: 'NFL', team: 'Houston Texans'},
  //     {league: 'NFL', team: 'Indianapolis Colts'},
  //     {league: 'NFL', team: 'Jacksonville Jaguars'},
  //     {league: 'NFL', team: 'Kansas City Chiefs'},
  //     {league: 'NFL', team: 'Las Vegas Raiders'},
  //     {league: 'NFL', team: 'Los Angeles Chargers'},
  //     {league: 'NFL', team: 'Los Angeles Rams'},
  //     {league: 'NFL', team: 'Miami Dolphins'},
  //     {league: 'NFL', team: 'Minnesota Vikings'},
  //     {league: 'NFL', team: 'New England Patriots'},
  //     {league: 'NFL', team: 'New Orleans Saints'},
  //     {league: 'NFL', team: 'New York Giants'},
  //     {league: 'NFL', team: 'New York Jets'},
  //     {league: 'NFL', team: 'Philadelphia Eagles'},
  //     {league: 'NFL', team: 'Pittsburgh Steelers'},
  //     {league: 'NFL', team: 'San Francisco 49ers'},
  //     {league: 'NFL', team: 'Seattle Seahawks'},
  //     {league: 'NFL', team: 'Tampa Bay Buccaneers'},
  //     {league: 'NFL', team: 'Tennessee Titans'},
  //     {league: 'NFL', team: 'Washington Commanders'},
  //     //
  //     {league: 'NBA', team: 'Boston Celtics'},
  //     {league: 'NBA', team: 'Brooklyn Nets'},
  //     {league: 'NBA', team: 'New York Knicks'},
  //     {league: 'NBA', team: 'Philadelphia 76ers'},
  //     {league: 'NBA', team: 'Toronto Raptors'},
  //     {league: 'NBA', team: 'Chicago Bulls'},
  //     {league: 'NBA', team: 'Cleveland Cavaliers'},
  //     {league: 'NBA', team: 'Detroit Pistons'},
  //     {league: 'NBA', team: 'Indiana Pacers'},
  //     {league: 'NBA', team: 'Milwaukee Bucks'},
  //     {league: 'NBA', team: 'Atlanta Hawks'},
  //     {league: 'NBA', team: 'Charlotte Hornets'},
  //     {league: 'NBA', team: 'Miami Heat'},
  //     {league: 'NBA', team: 'Orlando Magic'},
  //     {league: 'NBA', team: 'Washington Wizards'},
  //     {league: 'NBA', team: 'Denver Nuggets'},
  //     {league: 'NBA', team: 'Minnesota Timberwolves'},
  //     {league: 'NBA', team: 'Oklahoma City Thunder'},
  //     {league: 'NBA', team: 'Portland Trail Blazers'},
  //     {league: 'NBA', team: 'Utah Jazz'},
  //     {league: 'NBA', team: 'Golden State Warriors'},
  //     {league: 'NBA', team: 'Los Angeles Clippers'},
  //     {league: 'NBA', team: 'Los Angeles Lakers'},
  //     {league: 'NBA', team: 'Phoenix Suns'},
  //     {league: 'NBA', team: 'Sacramento Kings'},
  //     {league: 'NBA', team: 'Dallas Mavericks'},
  //     {league: 'NBA', team: 'Houston Rockets'},
  //     {league: 'NBA', team: 'Memphis Grizzlies'},
  //     {league: 'NBA', team: 'New Orleans Pelicans'},
  //     {league: 'NBA', team: 'San Antonio Spurs'},
  //     //
  //     {league: 'MLB', team: 'Baltimore Orioles'},
  //     {league: 'MLB', team: 'New York Yankees'},
  //     {league: 'MLB', team: 'Boston Red Socks'},
  //     {league: 'MLB', team: 'Tampa Bay Rays'},
  //     {league: 'MLB', team: 'Toronto Blue Jays'},
  //     {league: 'MLB', team: 'Cleveland Guardians'},
  //     {league: 'MLB', team: 'Minnesota Twins'},
  //     {league: 'MLB', team: 'Kansas City Royals'},
  //     {league: 'MLB', team: 'Detroit Tigers'},
  //     {league: 'MLB', team: 'Chicago White Sox'},
  //     {league: 'MLB', team: 'Houston Astros'},
  //     {league: 'MLB', team: 'Seattle Mariners'},
  //     {league: 'MLB', team: 'Texas Rangers'},
  //     {league: 'MLB', team: 'Los Angeles Angels'},
  //     {league: 'MLB', team: 'Oakland Athletics'},
  //     {league: 'MLB', team: 'Philadelphia Phillies'},
  //     {league: 'MLB', team: 'Atlanta Braves'},
  //     {league: 'MLB', team: 'New York Mets'},
  //     {league: 'MLB', team: 'Washington Nationals'},
  //     {league: 'MLB', team: 'Miami Marlins'},
  //     {league: 'MLB', team: 'Milwaukee Brewers'},
  //     {league: 'MLB', team: 'St. Louis Cardinals'},
  //     {league: 'MLB', team: 'Chicago Cubs'},
  //     {league: 'MLB', team: 'Cincinnati Reds'},
  //     {league: 'MLB', team: 'Pittsburgh Pirates'},
  //     {league: 'MLB', team: 'Los Angeles Dodgers'},
  //     {league: 'MLB', team: 'Arizona Diamondbacks'},
  //     {league: 'MLB', team: 'San Diego Padres'},
  //     {league: 'MLB', team: 'San Francisco Giants'},
  //     {league: 'MLB', team: 'Colorado Rockies'},
  //     //
  //     {league: 'NHL', team: 'Carolina Hurricanes'},
  //     {league: 'NHL', team: 'Columbus Blue Jackets'},
  //     {league: 'NHL', team: 'New Jersey Devils'},
  //     {league: 'NHL', team: 'New York Islanders'},
  //     {league: 'NHL', team: 'New York Rangers'},
  //     {league: 'NHL', team: 'Philadelphia Flyers'},
  //     {league: 'NHL', team: 'Pittsburgh Penguins'},
  //     {league: 'NHL', team: 'Washington Capitals'},
  //     {league: 'NHL', team: 'Boston Bruins'},
  //     {league: 'NHL', team: 'Buffalo Sabres'},
  //     {league: 'NHL', team: 'Detroit Red Wings'},
  //     {league: 'NHL', team: 'Florida Panthers'},
  //     {league: 'NHL', team: 'Montreal Canadiens'},
  //     {league: 'NHL', team: 'Ottawa Senators'},
  //     {league: 'NHL', team: 'Tampa Bay Lightning'},
  //     {league: 'NHL', team: 'Toronto Maple Leafs'},
  //     {league: 'NHL', team: 'Chicago Blackhawks'},
  //     {league: 'NHL', team: 'Colorado Avalanche'},
  //     {league: 'NHL', team: 'Dallas Stars'},
  //     {league: 'NHL', team: 'Minnesota Wild'},
  //     {league: 'NHL', team: 'Nashville Predators'},
  //     {league: 'NHL', team: 'St. Louis Blues'},
  //     {league: 'NHL', team: 'Utah Hockey Club'},
  //     {league: 'NHL', team: 'Winnipeg Jets'},
  //     {league: 'NHL', team: 'Anaheim Ducks'},
  //     {league: 'NHL', team: 'Calgary Flames'},
  //     {league: 'NHL', team: 'Edmonton Oilers'},
  //     {league: 'NHL', team: 'Los Angeles Kings'},
  //     {league: 'NHL', team: 'San Jose Sharks'},
  //     {league: 'NHL', team: 'Seattle Kraken'},
  //     {league: 'NHL', team: 'Vancouver Canucks'},
  //     {league: 'NHL', team: 'Vegas Golden Knights'}
  // 	]
  // 	)

  const [groupName, setGroupName] = useState();
  const [sport, setSport] = useState();
  const [league, setLeague] = useState();
  const [season, setSeason] = useState();
  const [openingDateTime, setOpeningDateTime] = useState();
  const [closingDateTime, setClosingDateTime] = useState();
  const [events, setEvents] = useState([]);
  // eslint-disable-next-line
  const [gameType, setGameType] = useState();
  const [homeTeam, setHomeTeam] = useState();
  const [awayTeam, setAwayTeam] = useState();
  // eslint-disable-next-line
  const [matchdayAvaiableTime, setMatchdayAvailableTime] = useState();
  // eslint-disable-next-line
  const [matchdayClosingTime, setMatchdayClosingTime] = useState();
  // eslint-disable-next-line
  const [isStarGame, setIsStarGame] = useState();

  const [createEventModalIsVisible, setCreateEventModalIsVisible] =
    useState(false);
  const toggleCreateEventModal = () => {
    setCreateEventModalIsVisible(!createEventModalIsVisible);
  };

  const [teamsTaken, setTeamsTaken] = useState([]);

  const createEvent = () => {
    let newEvents = events;
    let isStarGameBoolean = isStarGame === "true" ? true : false;
    newEvents.push({
      homeTeam: homeTeam,
      awayTeam: awayTeam,
      isStarGame: isStarGameBoolean,
    });

    let newTeamsTaken = teamsTaken;
    newTeamsTaken.push(homeTeam);
    newTeamsTaken.push(awayTeam);
    setTeamsTaken(newTeamsTaken);

    setHomeTeam("");
    setAwayTeam("");
    setIsStarGame("");

    setEvents(newEvents);
    toggleCreateEventModal();
    // try {
    //   setIsLoading(true);

    //   await addDoc(collection(db, "events"), {
    //     uid: uuidv4(),
    // 		dateCreated: new Date().toISOString(),
    // 		sport: sport,
    // 		league: league,
    // 		gameType: gameType,
    // 		homeTeam: homeTeam,
    // 		awayTeam: awayTeam,
    // 		matchdayAvailableTime: matchdayAvaiableTime,
    // 		matchdayClosingTime: matchdayClosingTime,
    // 		isStarGame: isStarGame
    //   })

    //   navigate(-1)

    //   setIsLoading(false);
    // } catch (err) {
    //   console.error(err);
    //   alert(err.message);
    //   setIsLoading(false);
    // }
  };

  const [eventToEdit, setEventToEdit] = useState();
  const [eventToEditHomeTeam, setEventToEditHomeTeam] = useState();
  const [eventToEditAwayTeam, setEventToEditAwayTeam] = useState();
  const [eventToEditIsStarGame, setEventToEditIsStarGame] = useState();
  const [editEventModalIsVisible, setEditEventModalIsVisible] = useState(false);
  const toggleEditEventModal = (event) => {
    if (event) {
      setEventToEdit(event);
      setEventToEditHomeTeam(event.homeTeam);
      setEventToEditAwayTeam(event.awayTeam);
      setEventToEditIsStarGame(event.isStarGame);
    }
    setEditEventModalIsVisible(!editEventModalIsVisible);
  };

  const saveChangesToEvent = () => {
    let newEvents = events;
    newEvents.forEach((event) => {
      if (
        event.homeTeam === eventToEdit.homeTeam &&
        event.awayTeam === eventToEdit.awayTeam
      ) {
        event.homeTeam = eventToEditHomeTeam;
        event.awayTeam = eventToEditAwayTeam;
        event.isStarGame = eventToEditIsStarGame === "true" ? true : false;
      }
    });

    let newTeamsTaken = teamsTaken;
    newTeamsTaken = newTeamsTaken.filter((team) => {
      return team !== eventToEdit.homeTeam && team !== eventToEdit.awayTeam;
    });
    newTeamsTaken.push(eventToEditHomeTeam);

    setEvents(newEvents);
    toggleEditEventModal();
  };

  const deleteEvent = () => {
    let newEvents = events;
    newEvents = newEvents.filter((event) => {
      return (
        event.homeTeam !== eventToEdit.homeTeam &&
        event.awayTeam !== eventToEdit.awayTeam
      );
    });

    let newTeamsTaken = teamsTaken;
    newTeamsTaken = newTeamsTaken.filter((team) => {
      return team !== eventToEdit.homeTeam && team !== eventToEdit.awayTeam;
    });
    setTeamsTaken(newTeamsTaken);

    setEvents(newEvents);
    toggleEditEventModal();
  };

  const [rooms, setRooms] = useState([]);
  const fetchRooms = async () => {
    const rooms = await getDocs(collection(db, "rooms"));
    let roomsArray = [];
    rooms.forEach((room) => {
      roomsArray.push(room.data());
    });
    setRooms(roomsArray);
  };
  useEffect(() => {
    fetchRooms();
  }, []);

  const createGroup = async () => {
    // const roomMembers = rooms.find(room => (room.leagueName === league && room.season === season)).members
    // const roomMemberEmails = roomMembers.map(member => member.email).join(', ');

    try {
      setIsLoading(true);

      // Check for duplicate groups before creating (prevent double-click/lag issues)
      const existingGroupsQuery = query(
        collection(db, "groups"),
        where("league", "==", league),
        where("tournament", "==", season),
        where("name", "==", groupName)
      );
      const existingGroupsSnap = await getDocs(existingGroupsQuery);

      if (!existingGroupsSnap.empty) {
        setIsLoading(false);
        alert(
          `A group named "${groupName}" already exists for ${league} - ${season}. Please use a different name or edit the existing group.`
        );
        return;
      }

      // Create one group per tournament type for the selected tournament (season)
      const tournamentTypes = [
        { key: "casual", label: "Casual" },
        { key: "standard", label: "Standard" },
        { key: "highStakes", label: "HighStakes" },
        { key: "vipExclusive", label: "VIPExclusive" },
      ];

      // Find room UIDs corresponding to the selected league + season + tournamentType
      const roomsForLeagueSeason = rooms.filter(
        (r) => r.leagueName === league && r.season === season
      );

      for (const tt of tournamentTypes) {
        const matchingRoom = roomsForLeagueSeason.find((r) => {
          const t = (
            r.tournamentType ||
            r.tournamenttype ||
            "casual"
          ).toString();
          return t.toLowerCase() === tt.key.toLowerCase();
        });

        await addDoc(collection(db, "groups"), {
          uid: uuidv4(),
          name: groupName,
          dateCreated: new Date().toISOString(),
          sport: sport,
          league: league,
          // store the tournament (season) string for reference
          tournament: season ? season : null,
          tournamentType: tt.key,
          tournamentRoomUid: matchingRoom ? matchingRoom.uid : null,
          openingDateTime: openingDateTime,
          closingDateTime: closingDateTime,
          events: events,
          drivers: league === "Formula 1" ? formula1Drivers : null,
          hasClosingReminderSent: false,
          hasOpeningEmailSent: false,
        });
      }

      // const serviceId = 'sportleague_outlook';
      // const templateId = 'newGroupNotification';
      // const publicKey = 'Ki5BETKiWrS6RDEP_';

      // const leagueUid = leagues.find(l => l.name === league).uid;

      // const templateParams = {
      // 	to: roomMemberEmails,
      // 	group: groupName,
      // 	league: league,
      // 	linkToLeague: `https://app.sportleague.com/play/leagues/${leagueUid}`,
      // 	season: season,
      // 	sport: sport,
      // 	openingDatetime: new Date(openingDateTime).toString(),
      // 	closingDatetime: new Date(closingDateTime).toString(),
      // }

      // await emailjs.send(serviceId, templateId, templateParams, publicKey).then(
      // 	(response) => {
      // 		console.log('SUCCESS!', response.status, response.text);
      // 	},
      // 	(error) => {
      // 		console.log('FAILED...', error);
      // 	},
      // );

      navigate(-1);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert(err.message);
      setIsLoading(false);
    }
  };

  const [formula1Drivers, setFormula1Drivers] = useState();
  const fetchFormula1Drivers = async () => {
    try {
      setIsLoading(true);
      const q = query(
        collection(db, "leagues"),
        where("name", "==", "Formula 1")
      );
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      const drivers = data.drivers;
      setFormula1Drivers(drivers);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching Formula 1 drivers");
    }
  };
  useEffect(() => {
    fetchFormula1Drivers();
    // eslint-disable-next-line
  }, []);

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        CREATE GROUP
      </h1>
      <div>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Name
        </p>
        <input
          type="text"
          className="mainInput"
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
          placeholder="The group's name"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Sport
        </p>
        <Input
          type="select"
          className="mainInput"
          value={sport}
          onChange={(e) => setSport(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value="" disabled>
            The event's sport
          </option>
          {sports.map((sport) => {
            return <option value={sport}>{sport}</option>;
          })}
        </Input>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          League
        </p>
        <Input
          type="select"
          className="mainInput"
          value={league?.name}
          onChange={(e) => setLeague(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
          disabled={!sport}
        >
          <option value="" disabled>
            The event's league
          </option>
          {
            // eslint-disable-next-line
            leagues?.map((league) => {
              if (league?.sportCategory === sport?.toUpperCase()) {
                return <option value={league?.name}>{league?.name}</option>;
              }
            })
          }
        </Input>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Tournament
        </p>
        <Input
          type="select"
          className="mainInput"
          value={season}
          onChange={(e) => setSeason(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
          disabled={!league}
        >
          <option value="" disabled>
            Select tournament (season)
          </option>
          {
            // list unique active seasons for the selected league
            Array.from(
              new Set(
                rooms
                  .filter((room) => room.leagueName === league && room.isActive)
                  .map((r) => r.season)
                  .filter(Boolean)
              )
            ).map((s) => (
              <option value={s}>{s}</option>
            ))
          }
        </Input>
        {/* Phase removed */}
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Opening date & time
        </p>
        <Input
          type="datetime-local"
          className="mainInput"
          value={openingDateTime}
          onChange={(e) => setOpeningDateTime(e.target.value)}
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Closing date & time
        </p>
        <Input
          type="datetime-local"
          className="mainInput"
          value={closingDateTime}
          onChange={(e) => setClosingDateTime(e.target.value)}
          style={{ marginBottom: "0.5rem" }}
        />
        {sport === "Racing" ? (
          <>
            <p className="inputLabel" style={{ textAlign: "left" }}>
              Driver(s)
            </p>
            <a href="/admin/leagues/20">
              <Button className="primaryBtn" style={{ marginBottom: "0.5rem" }}>
                EDIT DRIVERS
              </Button>
            </a>
            {formula1Drivers?.map((driver) => {
              return (
                <Button
                  className="secondaryBtn"
                  style={{ marginBottom: "0.5rem" }}
                >
                  {driver.name}
                </Button>
              );
            })}
          </>
        ) : (
          <>
            <p className="inputLabel" style={{ textAlign: "left" }}>
              Event(s)
            </p>
            <Button
              onClick={toggleCreateEventModal}
              className="primaryBtn"
              style={{ marginBottom: "0.5rem" }}
              disabled={!sport || !league}
            >
              CREATE EVENT
            </Button>
            <Modal
              id="serviceSelectModal"
              isOpen={createEventModalIsVisible}
              toggle={toggleCreateEventModal}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose onClick={toggleCreateEventModal} />
                </div>
                <div>
                  <h1>CREATE EVENT</h1>
                  <div style={{ marginTop: "1rem" }}>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Home team
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={homeTeam}
                      onChange={(e) => setHomeTeam(e.target.value)}
                      defaultValue={""}
                      style={{ marginBottom: "0.5rem" }}
                      disabled={!league}
                    >
                      <option value="" disabled>
                        The event's home team
                      </option>
                      {
                        // eslint-disable-next-line
                        teams?.map((team) => {
                          if (team.league === league) {
                            return (
                              <option
                                value={team.name}
                                disabled={
                                  team.name === awayTeam ||
                                  (team.league !== "NBA" &&
                                    team.league !== "MLB" &&
                                    team.league !== "NHL" &&
                                    teamsTaken.includes(team.name))
                                }
                              >
                                {team.name}
                              </option>
                            );
                          }
                        })
                      }
                    </Input>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Away team
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={awayTeam}
                      onChange={(e) => setAwayTeam(e.target.value)}
                      defaultValue={""}
                      style={{ marginBottom: "0.5rem" }}
                      disabled={!league}
                    >
                      <option value="" disabled>
                        The event's away team
                      </option>
                      {
                        // eslint-disable-next-line
                        teams?.map((team) => {
                          if (team.league === league) {
                            return (
                              <option
                                value={team.name}
                                disabled={
                                  team.name === homeTeam ||
                                  (team.league !== "NBA" &&
                                    team.league !== "MLB" &&
                                    team.league !== "NHL" &&
                                    teamsTaken.includes(team.name))
                                }
                              >
                                {team.name}
                              </option>
                            );
                          }
                        })
                      }
                    </Input>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Star game
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={isStarGame}
                      onChange={(e) => setIsStarGame(e.target.value)}
                      defaultValue={""}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <option value="" disabled>
                        Is this event a star game?
                      </option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </Input>
                    <Button
                      onClick={createEvent}
                      className="primaryBtn"
                      style={{ marginTop: "0.5rem" }}
                      disabled={!homeTeam || !awayTeam || !isStarGame}
                    >
                      CREATE EVENT
                    </Button>
                  </div>
                </div>
              </ModalBody>
            </Modal>
            {events?.length === 0 ? (
              <p style={{ textAlign: "center", marginBottom: "0.5rem" }}>
                No events created
              </p>
            ) : (
              events?.map((event) => {
                return (
                  <Button
                    onClick={() => toggleEditEventModal(event)}
                    className="secondaryBtn"
                    style={{ marginBottom: "0.5rem" }}
                  >
                    {event.isStarGame ? "⭐ " : null}
                    {event.homeTeam.toUpperCase()} VS{" "}
                    {event.awayTeam.toUpperCase()}
                    {event.isStarGame ? "⭐ " : null}
                  </Button>
                );
              })
            )}
            <Modal
              id="editEventModal"
              isOpen={editEventModalIsVisible}
              toggle={toggleEditEventModal}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose onClick={toggleEditEventModal} />
                </div>
                <div>
                  <h1>EDIT EVENT</h1>
                  <div style={{ marginTop: "1rem" }}>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Home team
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={eventToEditHomeTeam}
                      onChange={(e) => setEventToEditHomeTeam(e.target.value)}
                      defaultValue={""}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <option value="" disabled>
                        The event's home team
                      </option>
                      {
                        // eslint-disable-next-line
                        teams?.map((team) => {
                          if (team.league === league) {
                            return (
                              <option
                                value={team.name}
                                disabled={
                                  team.name === eventToEditAwayTeam ||
                                  (team.league !== "NBA" &&
                                    team.league !== "MLB" &&
                                    team.league !== "NHL" &&
                                    teamsTaken.includes(team.name))
                                }
                              >
                                {team.name}
                              </option>
                            );
                          }
                        })
                      }
                    </Input>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Away team
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={eventToEditAwayTeam}
                      onChange={(e) => setEventToEditAwayTeam(e.target.value)}
                      defaultValue={""}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <option value="" disabled>
                        The event's away team
                      </option>
                      {
                        // eslint-disable-next-line
                        teams?.map((team) => {
                          if (team.league === league) {
                            return (
                              <option
                                value={team.name}
                                disabled={
                                  team.name === eventToEditHomeTeam ||
                                  (team.league !== "NBA" &&
                                    team.league !== "MLB" &&
                                    team.league !== "NHL" &&
                                    teamsTaken.includes(team.name))
                                }
                              >
                                {team.name}
                              </option>
                            );
                          }
                        })
                      }
                    </Input>
                    <p className="inputLabel" style={{ textAlign: "left" }}>
                      Star game
                    </p>
                    <Input
                      type="select"
                      className="mainInput"
                      value={eventToEditIsStarGame}
                      onChange={(e) => setEventToEditIsStarGame(e.target.value)}
                      defaultValue={""}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      <option value="" disabled>
                        Is this event a star game?
                      </option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </Input>
                    <Button
                      onClick={saveChangesToEvent}
                      className="primaryBtn"
                      style={{ marginTop: "0.5rem" }}
                      disabled={!eventToEditHomeTeam || !eventToEditAwayTeam}
                    >
                      SAVE CHANGES
                    </Button>
                    <Button
                      onClick={deleteEvent}
                      className="secondaryBtn"
                      style={{ marginTop: "0.5rem", color: "#005EE1" }}
                    >
                      DELETE EVENT
                    </Button>
                  </div>
                </div>
              </ModalBody>
            </Modal>
          </>
        )}

        {/* <p className='inputLabel' style={{textAlign: 'left'}}>
					Type
        </p>
				<Input
          type="select"
          className="mainInput"
					value={gameType}
          onChange={(e) => setGameType(e.target.value)}
          defaultValue={''}
					style={{marginBottom: '0.5rem'}}
        >
          <option value='' disabled>The event's type</option>
          <option value='Matchday'>Matchday</option>
					<option value='Week gameday'>Week gameday</option>
        </Input>
				<p className='inputLabel' style={{textAlign: 'left'}}>
					Home team
        </p>
				<Input
          type="select"
          className="mainInput"
					value={homeTeam}
          onChange={(e) => setHomeTeam(e.target.value)}
          defaultValue={''}
					style={{marginBottom: '0.5rem'}}
					disabled={!league}
        >
          <option value='' disabled>The event's home team</option>
					{
						// eslint-disable-next-line
						teams.map((team) => {
							if (team.league === league){
								return (
									// eslint-disable-next-line
									<option value={team.team} disabled={team.team == awayTeam}>{team.team}</option>
								)
							}
						})
					}
        </Input>
				<p className='inputLabel' style={{textAlign: 'left'}}>
					Away team
        </p>
				<Input
          type="select"
          className="mainInput"
					value={awayTeam}
          onChange={(e) => setAwayTeam(e.target.value)}
          defaultValue={''}
					style={{marginBottom: '0.5rem'}}
					disabled={!league}
        >
          <option value='' disabled>The event's away team</option>
					{
						// eslint-disable-next-line
						teams.map((team) => {
							if (team.league === league){
								return (
									// eslint-disable-next-line
									<option value={team.team} disabled={team.team == homeTeam}>{team.team}</option>
								)
							}
						})
					}
        </Input>
				{
					gameType === 'Matchday' ?
					<>
						<p className='inputLabel' style={{textAlign: 'left'}}>
							Matchday available time
						</p>
						<Input
							type="datetime-local"
							className="mainInput"
							value={matchdayAvaiableTime}
							onChange={(e) => setMatchdayAvailableTime(e.target.value)}
							style={{marginBottom: '0.5rem'}}
						/>
						<p className='inputLabel' style={{textAlign: 'left'}}>
							Matchday closing time
						</p>
						<Input
							type="datetime-local"
							className="mainInput"
							value={matchdayClosingTime}
							onChange={(e) => setMatchdayClosingTime(e.target.value)}
							style={{marginBottom: '0.5rem'}}
						/>
					</>
					:
					null
				}
				<p className='inputLabel' style={{textAlign: 'left'}}>
					Star game
				</p>
				<Input
					type="select"
					className="mainInput"
					value={isStarGame}
					onChange={(e) => setIsStarGame(e.target.value)}
					defaultValue={''}
					style={{marginBottom: '0.5rem'}}
				>
					<option value='' disabled>Is this a star game?</option>
					<option value='Yes'>Yes</option>
					<option value='No'>No</option>
				</Input> */}
        <Button
          onClick={createGroup}
          className="primaryBtn"
          style={{ marginTop: "1rem" }}
          disabled={
            isLoading ||
            !groupName ||
            !sport ||
            !league ||
            !openingDateTime ||
            !closingDateTime ||
            (events.length === 0 && sport !== "Racing")
          }
        >
          {isLoading ? "CREATING..." : "CREATE GROUP"}
        </Button>
      </div>
    </div>
  );
}

export default AdminCreateGroupPage;
